export const FORM_FIELDS_MAP = {
  AccountableRecruiter: {
    key: 'accountableRecruiter'
  },
  Candidate: {
    key: 'candidate'
  },
  CandidateRecruiter: {
    key: 'candidateRecruiter'
  },
  SendoverReasons: {
    key: 'sendoverReasons'
  },
  Comments: {
    key: 'comments'
  }
};
